<template>
    <div>
         <div :id="svgContentId" v-if="hasData">
             <div style="display:table;">
                 <div :id="chartId" style="display: table-cell; vertical-align: middle;"></div>
                 <div :id="legendId" style="display: table-cell; vertical-align: middle;"></div>
             </div>
         </div>
    </div>
</template>

<script>
const d3 = require("d3");
export default {
  props: {
    doughnutChartdata: {
        type: Array,
        default: () => []
    }
  },

  computed: {
      svgContentId() {
          return __.uniqueId('svgContent')
      },
      chartId() {
          return __.uniqueId('chart')
      },
      legendId() {
          return __.uniqueId('legend')
      },
      hasData() {
          return this.doughnutChartdata.length > 0
      }
  },
  watch:{
        doughnutChartdata(val) {
            if(val.length > 0)
            {
             var myNode1 = document.getElementById(this.chartId);
             var myNode2 = document.getElementById(this.legendId);
             if(myNode1 != null && myNode1 != null )
             {
                  myNode1.innerHTML = '';
                  myNode2.innerHTML = '';
                  this.onCreate()
             }
            }

        },
    },

  methods: {
    onCreate() {
        var defaultColors = [
            '#AA99D6' , //sick
            '#ACD8E8', //Casual
            '#FABCD3', //Paid
            '#F2F0BF', //unpaid

            "#7FC6F4", // blue
            "#FAD971", // yellow
            "#F3999A", // pink
            "#75E6A1", // green
            "#ABD8E8", // light blue
            "#F2F0BE", // light yellow
            "#EDCD6B", // yellow 2
        ];

        var data = this.doughnutChartdata;

        var margin = { top: 0, left: 0, bottom: 0, right: 0 },
        width = parseInt(d3.select(`#${this.svgContentId}`).style("width")),
        width = width - margin.left - margin.right,
        mapRatio = 0.55,
        height = width * mapRatio;

        var radius = Math.min(width, height) / 2;
        var color = d3.scaleOrdinal(defaultColors.slice(0, data.length));
        var arc = d3
        .arc()
        .outerRadius(radius)
        .innerRadius(radius - 20);
        var arcOver = d3.arc();

        var svg = d3
        .select(`#${this.chartId}`)
        .append("svg")
        .attr("width", 0.6 * width)
        .attr("height", height)
        .append("g")
        .attr(
            "transform",
            "translate(" + (0.6 * width) / 2 + "," + height / 2 + ")"
        );
        var div = d3
        .select("body")
        .append("div")
        .attr("class", "tooltip");
        var pie = d3
        .pie()
        .sort(null)
        .value(function(d) {
            return d.Count;
        });
        var g = svg
        .selectAll(".arc")
        .data(pie(data))
        .enter()
        .append("g")
        .attr("class", "arc")
        .on("mousemove", function(event,d) {
            var mouseVal = d3.pointer(event);
            div.style("display", "none");
            div
            .html(
                '<p style="text-align: left;"><b>' +
                d.data.LeaveType +
                "</b></p>" +
                '<p style="text-align: left;">' +
                d.data.Count +
                " Leaves</p>"
            )

            .style("left", event.pageX + 12 + "px")
            .style("top", event.pageY - 10 + "px")
            .style("opacity", 1)
            .style("display", "block");
        })
        .on("mouseout", function() {
            div.html(" ").style("display", "none");
        });

        g.append("path")
        .attr("d", arc)
        .style("fill", function(d, i) {
            return color(i);
        });

        let legend = d3
        .select(`#${this.legendId}`)
        .append("div")
        .attr("class", "legend")
        .attr("id", "doughnutLegend");

        let keys = legend
        .selectAll(".key")
        .data(data)
        .enter()
        .append("div")
        .attr("class", "key")
        .style("display", "flex")
        .style("align-items", "center")
        .style("margin-right", "30px");

        keys
        .append("div")
        .attr("class", "symbol")
        .style("height", "15px")
        .style("width", "30px")
        .style("margin", "10px 10px")
        .style("border-radius", "10px")
        .style("background-color", (d, i) => color(i));

        keys
        .append("div")
        .attr("class", "name")
        .html(
            d =>
            "<b>" +
            `${d.LeaveType} ` +
            "</b>" +
            '<br /><p style="opacity:0.6px">' +
            `${d.Count} ` +
            "  Leaves</p>"
        )
        .style("margin-top", "10px");

        keys.exit().remove();
    }
  },

  mounted() {
      if(this.hasData) {
          this.onCreate()
      }
  }
};
</script>
<style>
.pie text {
  fill: #000;
}

.pie .name-text {
  font-size: 0.8em;
}

.pie .value-text {
  font-size: 3em;
}

.tooltip {
  position: absolute;
  text-align: center;

  padding: 10px;
  font: 12px sans-serif;
  background: white;
  border: 0px;
  border-radius: 8px;
  color: black;
  box-shadow: -3px 3px 15px #888888;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/LeaveManagement/Chart.vue